import React from "react";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";
import s from "./StatusWrapper.module.scss";

const StatusWrapper = ({
  variant = "grey",
  size = "small",
  status,
  icon,
  children,
  className = "",
  shape = "pill",
  clickable = false,
  onClick,
  style = {},
  testId,
  ...props
}) => {
  const { t } = useTranslation();

  const classNames = [
    s["status-wrapper"],
    s[`variant-${variant}`],
    s[`size-${size}`],
    s[`shape-${shape}`],
    className,
    icon && s["icon-container"]
  ].filter(Boolean).join(" ");

  const getContent = () => {
    if (children) {
      return children;
    }
    
    if (status) {
      const translatedStatus = t(status);
      const displayText = translatedStatus !== status ? translatedStatus : status.replace(/_/g, " ");
      
      return (
        <Typography component="span">
          {displayText}
        </Typography>
      );
    }
    
    return null;
  };

  const handleClick = (e) => {
    if (clickable && onClick) {
      onClick(e);
    }
  };

  return (
    <div
      className={classNames}
      style={style}
      data-testid={testId}
      {...props}
    >
      {getContent()}
      {icon && <div className={s["icon-container"]} onClick={handleClick} style={{ cursor: clickable ? "pointer" : "default" }}>{icon}</div>}
    </div>
  );
};

export default StatusWrapper;